module.exports = __webpack_public_path__ + "indicator-2.png?06cf92a3af58b3ac1dd97fd992b5ab8f";